import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import SessionAssign from "./session-assign";

const AssignRSVPSessions = (props) => {
  const { manageTicketsCount, assignedAttendeeTickets } = props;
  // console.log("manageTicketsCount :- ", manageTicketsCount);

  const renderAssign = () => {
    let returnHtml = [];

    for (const [key, item] of Object.entries(assignedAttendeeTickets)) {
      let tid = key;

      let ticketCheck = _.filter(
        manageTicketsCount,
        (obj) => parseInt(obj?.ticketid) === parseInt(tid)
      );
      // console.log("ticketCheck :- ", ticketCheck);

      if (ticketCheck?.[0]?.rsvpsessions?.length > 0) {
        for (let i = 0; i < item?.length; i++) {
          let finalitem = item?.[i];

          returnHtml.push(
            <SessionAssign
              key={`tickets_key_${tid}_${i}`}
              form={`SessionAssignForm_${tid}_${i}`}
              ticketinfo={ticketCheck?.[0] ?? {}}
              assign={finalitem}
            />
          );
        }
      }
    }

    return returnHtml;
  };

  return (
    <>
      {!_.isEmpty(assignedAttendeeTickets) ? (
        <ul className="space-y-3">{renderAssign()}</ul>
      ) : (
        ""
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    manageTicketsCount: state.manageTicketsCount,
    assignedAttendeeTickets: state.assignedAttendeeTickets,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignRSVPSessions);
